/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedShippingInfoLink_user$ref = any;
export type PdpSharedDetailShipping_user$ref = any;
export type PdpSharedDetailShipping_user = {
    readonly " $fragmentRefs": PdpSharedShippingInfoLink_user$ref;
    readonly " $refType": PdpSharedDetailShipping_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedDetailShipping_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingInfoLink_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'bab6f1fe84d3ad648fb7f6c68a2a933f';
export default node;
